import { render, staticRenderFns } from "./project_chart.vue?vue&type=template&id=467d6998&scoped=true"
import script from "./project_chart.vue?vue&type=script&lang=js"
export * from "./project_chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467d6998",
  null
  
)

export default component.exports